import { render, staticRenderFns } from "./ChatCofenReportHeader.vue?vue&type=template&id=a3a3053a"
import script from "./ChatCofenReportHeader.vue?vue&type=script&lang=js"
export * from "./ChatCofenReportHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports